import { render, staticRenderFns } from "./LoginSSO.vue?vue&type=template&id=2e15f094&scoped=true"
import script from "./LoginSSO.vue?vue&type=script&lang=js"
export * from "./LoginSSO.vue?vue&type=script&lang=js"
import style0 from "./LoginSSO.vue?vue&type=style&index=0&id=2e15f094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15f094",
  null
  
)

export default component.exports